<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'초대하기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
            <div style="margin-top: 20px; padding: 0 12px;">
                <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">트레이닝을 참여하셨던 회원이나, 다이렉트 요청서 및 메시지를 주고 받은 회원분들만 초대할 수 있습니다</div>
            </div>
            <div style="margin-top: 8px; overflow-y: scroll; flex: 1; padding: 0 12px;">
                <MercenarySearchInput :enter="debounceAPISearch" :searchWord="searchWord" :setSearchWord="setSearchWord" :isShowCancelBtn="false" :placeholder="'검색'"></MercenarySearchInput>
                <div style="margin-top: 20px;">
                    <div @click="setInviteList(each)" v-for="each, i in invitationMembers" :key="i" style="display: flex; align-items: center; margin-bottom: 24px;">
                        <div style="margin-right: 8px;">
                            <ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>
                        </div>
                        <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.nic_name }}</div>
                            <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">{{ each.position }}</div>
                        </div>
                        <div v-if="inviteList.indexOf(each) !== -1">
                            <img style="width: 16px;" :src="require('@/assets/img/check_orange.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 99px; padding: 0 12px;">
                <div @click="inviteMember" :class="inviteList.length === 0 ? 'un_active' : 'active'" style="height: 48px; line-height: 48px; border-radius: 12px; text-align: center; margin-top: 12px; font-weight: 700; font-size: 14px;">초대하기</div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import MercenarySearchInput from '@/components/common/MercenarySearchInput'
import ProfileImage from '@/components/common/ProfileImage'
import _ from 'lodash';
import ResponseCode from '@/ResponseCode'

export default {
    name: 'InviteMemberPage',
    components: {
        MercenaryHeader, MercenarySearchInput, ProfileImage
    },
    props: {
        join_idx: {
            type: [String, Number],
            default: ''
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    created() {
        this.getInviteList()
        this.debounceAPISearch = _.debounce((e) => {
            this.enter(e);
        }, 600);
    },
    data() {
        return {
            searchWord: '',
            inviteList: [],
            invitationMembers: []
        }
    },
    methods: {
        debounceAPISearch: () => { },
        setSearchWord(searchWord) {
            this.searchWord = searchWord
        },
        enter(e) {
            this.searchWord = e.target.value
            this.getInviteList(this.searchWord)
        },
        setInviteList(test) {
            const index = this.inviteList.indexOf(test);
            if (index > -1) {
                this.inviteList.splice(index, 1);
            } else {
                this.inviteList.push(test);
            }
        },
        async inviteMember() {
            if (this.inviteList.length === 0) {
                this.$GlobalStore.showAlert('초대할 회원을 선택해주세요')
                return
            }
            this.$GlobalStore.showProgress()
            const transformInviteList = []
            this.inviteList.forEach(item => {
                transformInviteList.push({
                    member_idx: item.member_idx,
                    member_type: item.is_temp_coach
                })
            })
            const formData = new FormData
            formData.append('join_idx', this.join_idx)
            formData.append('invitation_members', JSON.stringify(transformInviteList))

            const res = await this.$Axios.post('/api/join/invitation/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.closeLastModal()
                this.completeAction(true)
            } else {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showAlert(res.data.msg)
            }

        },
        async getInviteList(searchWord) {
            const parameters = {}
            parameters.searchWord = searchWord
            parameters.join_idx = this.join_idx

            const res = await this.$Axios.get('/api/join/invitation/available/list', { params: parameters })

            const invitationMembers = res.data.invitation_members
            this.invitationMembers = invitationMembers
        }
    }
}
</script>

<style scoped>
.active {
    background-color: #210f03;
    color: var(--color-main);
}

.un_active {
    background-color: #f5f5f5;
    color: #d9d9d9;
}
</style>